import { Component, HostListener, Inject, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModifiedActionStatus } from 'apps/website/src/app/utils/public-api';
import { environment } from 'apps/website/src/environments/environment';
import { DataField } from '../table-ui/table-ui.component';
export interface DialogTableDataFields {
  fieldName: string,
  label: string,
  attachment?: boolean,
  statusField?: boolean,
  tableView?: boolean,
  html?: boolean,
  isDate?: boolean,
  tableDataFields?: DataField[],
  tableData?: any[],
  newSection?: boolean,
  isTitleOnly?: boolean,
}


@Component({
  selector: 'intrasense-common-view-detail',
  templateUrl: './common-view-detail.component.html',
  styleUrls: ['./common-view-detail.component.scss']
})
export class CommonViewDetailComponent implements OnInit {

  title!: string;
  dialogDataFields: DialogTableDataFields[] = [];
  dataArr: any[] = [];
  sectionArr: any[] = [];
  modalActions: any[] = [];
  assetsPathUrl = environment.assetsPathUrl;
  ModifiedActionStatus = ModifiedActionStatus;
  @Output() btnEvent = new EventEmitter<any>();

  constructor(
    private dialogRef: MatDialogRef<CommonViewDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { fields: DialogTableDataFields[], title: string, sourceData: any[], sections: any[], modalActions: any[] },
  ) { }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    if (event.target.innerWidth > 1200) {
      this.dialogRef.updateSize('40%');
    } else {
      this.dialogRef.updateSize('100%');
    }
  }

  ngOnInit(): void {
    if (window.innerWidth > 1200) {
      this.dialogRef.updateSize('40%');
    } else {
      this.dialogRef.updateSize('100%');
    };

    if (this.data.fields && this.data.title && this.data.sourceData) {
      this.title = this.data.title ? this.data.title : '';
      this.dataArr = this.data.sourceData.length > 0 ? this.data.sourceData : [];
      this.dialogDataFields = this.data.fields.length > 0 ? this.data.fields : [];
      this.modalActions = this.data.modalActions.length > 0 ? this.data.modalActions : []
      // this.sectionArr = this.data.sections.length > 0 ? this.data.sections : [];
    }
  }


  // close popup
  close() {
    document.getElementsByClassName("animate__animated")[0].classList.remove("animate__fadeInUp");
    document.getElementsByClassName("animate__animated")[0].classList.add("animate__fadeOutDown");
    setTimeout(() => { this.dialogRef.close(); }, 500);
  }

  previewImage(url: string) {
    if (url) {
      window.open(this.assetsPathUrl + url);
    }
  }

  btnClickHandler(data: any) {
    this.btnEvent.emit(data);
    this.dialogRef.close('edit');
  }

}
